import { render, staticRenderFns } from "./TermFormComponent.vue?vue&type=template&id=362134fe"
import script from "./TermFormComponent.vue?vue&type=script&lang=js"
export * from "./TermFormComponent.vue?vue&type=script&lang=js"
import style0 from "./TermFormComponent.vue?vue&type=style&index=0&id=362134fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports